if (!customElements.get('testimonials-carousel')) {
  class TestimonialsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-testimonials-track]');
      this.slides = Array.from(this.querySelectorAll('[data-testimonial-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-testimonial-dot]'));
      this.prevButton = this.querySelector('[data-testimonial-prev]');
      this.nextButton = this.querySelector('[data-testimonial-next]');

      if (this.slides.length === 0) return;

      this.currentIndex = Math.max(
        this.slides.findIndex((slide) => slide.classList.contains('is-active')),
        0
      );

      this.slides.forEach((slide, index) => {
        if (index !== this.currentIndex) slide.setAttribute('aria-hidden', 'true');
      });

      if (this.slides.length > 1) {
        this.prevButton?.addEventListener('click', () => {
          this.stopAutoplay();
          this.go(this.currentIndex - 1);
        });
        this.nextButton?.addEventListener('click', () => {
          this.stopAutoplay();
          this.go(this.currentIndex + 1);
        });
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.stopAutoplay();
            this.go(index);
          });
        });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            this.stopAutoplay();
            this.go(this.currentIndex - 1);
          } else if (event.key === 'ArrowRight') {
            this.stopAutoplay();
            this.go(this.currentIndex + 1);
          }
        });

        this.setupSwipe();

        if (this.dataset.autoplay === 'true') {
          this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 6000;
          this.addEventListener('mouseenter', () => this.stopAutoplay());
          this.addEventListener('mouseleave', () => this.startAutoplay());
          this.addEventListener('focusin', () => this.stopAutoplay());
          this.addEventListener('focusout', () => this.startAutoplay());
          this.startAutoplay();
        }
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    go(index) {
      const total = this.slides.length;
      const nextIndex = (index + total) % total;
      if (nextIndex === this.currentIndex) return;

      this.slides[this.currentIndex]?.classList.remove('is-active');
      this.slides[this.currentIndex]?.setAttribute('aria-hidden', 'true');
      this.dots[this.currentIndex]?.classList.remove('is-active');
      this.dots[this.currentIndex]?.setAttribute('aria-selected', 'false');

      this.slides[nextIndex]?.classList.add('is-active');
      this.slides[nextIndex]?.removeAttribute('aria-hidden');
      this.dots[nextIndex]?.classList.add('is-active');
      this.dots[nextIndex]?.setAttribute('aria-selected', 'true');

      this.currentIndex = nextIndex;
      this.track.style.transform = 'translateX(-' + nextIndex * 100 + '%)';
    }

    startAutoplay() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => this.go(this.currentIndex + 1), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) clearInterval(this.autoplayTimer);
    }

    setupSwipe() {
      let startX = 0;
      let isDragging = false;

      this.track.addEventListener(
        'touchstart',
        (event) => {
          startX = event.touches[0].clientX;
          isDragging = true;
        },
        { passive: true }
      );

      this.track.addEventListener(
        'touchend',
        (event) => {
          if (!isDragging) return;
          isDragging = false;

          const endX = event.changedTouches[0].clientX;
          const diff = endX - startX;
          if (Math.abs(diff) < 40) return;

          this.stopAutoplay();
          if (diff < 0) this.go(this.currentIndex + 1);
          else this.go(this.currentIndex - 1);
        },
        { passive: true }
      );
    }
  }

  customElements.define('testimonials-carousel', TestimonialsCarousel);
}
